import { Observable } from 'rxjs';

import { ReturnReasonResponse } from '../../model/return-creation.model';

export abstract class ReturnReasonAdapter {
  abstract loadReasons(): Observable<ReturnReasonResponse>;
}
